import { Component, inject, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Api } from '../../services/api';
import { RegionService } from '../../services/region.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { CommonModule } from '@angular/common';
import { ChangeDetectorRef } from '@angular/core';
import { AlertService } from '../../services/alert.service';


@Component({
  selector: 'app-mdl-manage-budget',
  standalone: true,
  imports: [FormsModule, NgSelectModule, CommonModule],
  templateUrl: './mdl-manage-budget.html',
  styleUrls: ['./mdl-manage-budget.css'],
})
export class MdlManageBudget implements OnInit {
  private api = inject(Api);
  private regionService = inject(RegionService);
  private alertService = inject(AlertService);

  public regiones: { NombreRegion: string }[] = [];
  public comunasFact: string[] = [];
  public comunasEnv: string[] = [];

  minDate: string = '';
  cuentasFiltradas: any[] = [];
  cuentaBloqueada: boolean = false;
  oportunidadesOriginales: any[] = [];
  public nombreCuentaSeleccionada: string = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public mdl: MatDialogRef<MdlManageBudget>,
    private cdr: ChangeDetectorRef
  ) {}

  public presupuesto: any = {};
  public request: any = {
    presupuesto_id: '',
    nombre_presupuesto: '',
    fecha_caducidad: '',
    oportunidad_id: '',
    cuenta_id: '',
    id_estado: '',
    divisa_presupuesto: '',
    descripcion: '',
    impuestos: 0,
    envio: '',
    contacto_id: '',
    telefono: '',
    correo: '',
    nombre_fact: '',
    calle_fact: '',
    ciudad_fact: '',
    region_fact: '',
    pais_fact: 'Chile',
    nombre_env: '',
    calle_env: '',
    ciudad_env: '',
    region_env: '',
    pais_env: 'Chile',
    subtotal: 0,
    precio_total: 0,
  };

  public cuentas: any[] = [];
  public oportunidades: any[] = [];
  public contactos: any[] = [];
  public contactosFiltrados: any[] = [];
  public statuses: any = [];

  ngOnInit(): void {
    const today = new Date();
    const year = today.getFullYear();
    const month = (today.getMonth() + 1).toString().padStart(2, '0');
    const day = today.getDate().toString().padStart(2, '0');
    this.minDate = `${year}-${month}-${day}`;
    this.api.getAccounts().subscribe((response: any) => {
      if (Array.isArray(response.cuentas)) {
        this.cuentas = response.cuentas;
        this.cuentasFiltradas = [...this.cuentas];
        console.log(this.cuentas);
      } else {
        console.error(
          'La respuesta de la API no contiene un array de cuentas.'
        );
      }
    });

    this.loadStatuses();

    this.api.getOpportunities().subscribe((response: any) => {
      if (Array.isArray(response.oportunidades)) {
        this.oportunidades = response.oportunidades;
        this.oportunidadesOriginales = [...response.oportunidades];
        console.log(this.oportunidades);
      } else {
        console.error(
          'La respuesta de la API no contiene un array de oportunidades.'
        );
      }
    });

    this.api.getContacts().subscribe((response: any) => {
      if (Array.isArray(response.contactos)) {
        this.contactos = response.contactos;
      } else {
        console.error(
          'La respuesta de la API no contiene un array de contactos.'
        );
      }
    });

    this.regiones = this.regionService.getRegionesFull();

    this.request.region_fact = this.regiones[0]?.NombreRegion || '';
    this.getComunasFact(this.request.region_fact);

    this.request.region_env = this.regiones[0]?.NombreRegion || '';
    this.getComunasEnv(this.request.region_env);

    console.log(this.data);

    if (this.data.mode === 'edit') {
      this.presupuesto = this.data.budget;
      this.request.presupuesto_id = this.presupuesto.presupuesto_id;
      this.request.nombre_presupuesto =
        this.presupuesto.nombre_presupuesto || '';
      this.request.fecha_caducidad = this.presupuesto.fecha_caducidad || '';
      this.request.oportunidad_id = this.presupuesto.oportunidad_id || '';
      this.request.cuenta_id = this.presupuesto.cuenta_id || '';

      this.request.fecha_cuenta = this.presupuesto.fecha_cuenta || '';
      this.request.id_estado = this.presupuesto.id_estado || '';
      this.request.divisa_presupuesto =
        this.presupuesto.divisa_presupuesto || '';
      this.request.descripcion = this.presupuesto.descripcion || '';
      this.request.impuestos = this.presupuesto.impuestos || '';
      this.request.envio = this.presupuesto.envio || 0;
      this.request.contacto_id = this.presupuesto.contacto_id || '';
      this.request.telefono = this.presupuesto.telefono || '';
      this.request.correo = this.presupuesto.correo || '';
      this.request.nombre_fact = this.presupuesto.nombre_fact || '';
      this.request.calle_fact = this.presupuesto.calle_fact || '';
      this.request.ciudad_fact = this.presupuesto.ciudad_fact || '';
      this.request.region_fact = this.presupuesto.region_fact || '';
      this.request.pais_fact = 'Chile';
      this.request.nombre_env = this.presupuesto.nombre_env || '';
      this.request.calle_env = this.presupuesto.calle_env || '';
      this.request.ciudad_env = this.presupuesto.ciudad_env || '';
      this.request.region_env = this.presupuesto.region_env || '';
      this.request.pais_env = 'Chile';
      this.request.subtotal = 0;
      this.request.precio_total = 0;

      if (this.request.region_fact) {
        this.getComunasFact(this.request.region_fact);
      }
      if (this.request.region_env) {
        this.getComunasEnv(this.request.region_env);
      }
      const cuentaSeleccionada = this.cuentas.find(
        (c) => c.cuenta_id === this.request.cuenta_id
      );
      if (cuentaSeleccionada) {
        this.nombreCuentaSeleccionada = cuentaSeleccionada.nombre_empresa;
      }

      if (this.request.cuenta_id) {
        this.contactosFiltrados = this.contactos.filter(
          (contacto) => contacto.cuenta_id === this.request.cuenta_id
        );
      }
      console.log('🟢 Edit mode - cuenta asociada:', this.nombreCuentaSeleccionada);
console.log('📇 Contactos filtrados:', this.contactosFiltrados);
console.log('👤 Contacto seleccionado:', this.request.contacto_id);

      this.cdr.detectChanges();
    }
  }
  getComunasFact(region: string) {
    this.comunasFact = this.regionService.getComunasByRegion(region);
    if (this.comunasFact.length > 0 && !this.request.ciudad_fact) {
      this.request.ciudad_fact = this.comunasFact[0];
    }
  }

  getComunasEnv(region: string) {
    this.comunasEnv = this.regionService.getComunasByRegion(region);
    if (this.comunasEnv.length > 0 && !this.request.ciudad_env) {
      this.request.ciudad_env = this.comunasEnv[0];
    }
  }

  closeMdl() {
    this.mdl.close();
  }

  updateBudget() {
    this.api.showLoading();
    try {
      this.api.updateBudget(this.request).subscribe({
        next: (data: any) => {
          setTimeout(() => {
            this.api.hideLoading();
            window.location.reload();
            this.mdl.close(true);
          }, 500);
        },
        error: (err: any) => {
          this.api.hideLoading();
          if (err?.status===403){
            this.alertService.error('Acceso denegado','No tienes permiso para modificar presupuestos')
            this.mdl.close(false)
            return
          }
          this.alertService.error('Error','Ocurrió un error inesperado al actualizar el presupuesto')
          this.mdl.close(false)
        },
      });
    } catch (error) {
      console.error(error);
    }
  }

  createBudget() {
    this.api.showLoading();
    try {
      this.api.createBudget(this.request).subscribe({
        next: (data: any) => {
          setTimeout(() => {
            this.api.hideLoading();
            window.location.reload();
          }, 500);
        },
        error: (err: any) => {
          this.api.hideLoading();
          if (err?.status===403){
            this.alertService.error('Acceso denegado','No tienes permiso para crear presupuestos')
            this.mdl.close(false)
            return
          }
          this.alertService.error('Error','Ocurrió un error inesperado al crear el presupuesto')
          this.mdl.close(false)
          
        },
      });
    } catch (error) {
      console.error(error);
    }
  }

  onOportunidadSeleccionada(oportunidadId: string) {
    console.log('🟠 ID recibido:', oportunidadId);

    if (!oportunidadId) {
      this.request.cuenta_id = '';
      this.nombreCuentaSeleccionada = '';
      this.contactosFiltrados = [];
      this.cdr.detectChanges();
      return;
    }

    const oportunidadSeleccionada = this.oportunidades.find(
      (o) => o.oportunidad_id === oportunidadId
    );

    if (oportunidadSeleccionada) {
      const cuenta =
        oportunidadSeleccionada.cuenta ||
        this.cuentas.find(
          (c) => c.cuenta_id === oportunidadSeleccionada.cuenta_id
        );

      if (cuenta) {
        this.request.cuenta_id = cuenta.cuenta_id;
        this.nombreCuentaSeleccionada = cuenta.nombre_empresa;

        this.contactosFiltrados = this.contactos.filter(
          (contacto) => contacto.cuenta_id === cuenta.cuenta_id
        );

        console.log('📇 Contactos filtrados:', this.contactosFiltrados);
      } else {
        this.request.cuenta_id = '';
        this.nombreCuentaSeleccionada = '(Cuenta no encontrada)';
        this.contactosFiltrados = [];
      }

      this.cdr.detectChanges();
    }
  }


onchangeContactoSeleccionado(contacto: any) {
  if (contacto && typeof contacto === 'object') {
    this.request.telefono = contacto.telefono || '';
    this.request.correo = contacto.email || contacto.correo || '';
  } 
  else if (typeof contacto === 'string') {
    const encontrado = this.contactosFiltrados.find(
      (c: any) => c.contacto_id === contacto
    );
    this.request.telefono = encontrado?.telefono || '';
    this.request.correo = encontrado?.email || encontrado?.correo || '';
  } 
  else {
    this.request.telefono = '';
    this.request.correo = '';
  }

  console.log("📞 Teléfono:", this.request.telefono, "📧 Correo:", this.request.correo);
}

  loadStatuses() {
    this.api.getStatusByType({ tipo: 'PRE' }).subscribe({
      next: (data: any) => {
        this.statuses = data.data;
      },
      error: (error) => {
        console.error('Error fetching budget statuses:', error);
      },
    }); 
  }
}